export const MINIO_END_POINT = process.env.REACT_APP_MINIO_END_POINT;
